import { useMutation } from '@tanstack/vue-query';
import { getApi } from '../api';

export default () => useMutation({
  mutationFn: () => {
    const { api, baseURL } = getApi();
    return api
      .post(`/api/passkeys/register/options`, {}, { baseURL })
      .then((res) => res.data);
  },
});
